const defaultLocale = "lt";

const useLocale = () => {
  const locale = "lt";
  return locale ? locale.toLowerCase() : defaultLocale;
};

export default useLocale;
